// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"bbee9b2d","218":"ad6a2972","226":"9e9f0343","453":"68d2f560","506":"ddc7101c","748":"bae33262","947":"44409b4d","956":"f4e33765"}[chunkId] + ".chunk.js";
};